<template>
  <div>
    <swiper
      :options="{
        slidesPerView: 'auto',
        freeMode: true,
        initialSlide: tab - 1,
      }"
      class="swiper"
    >
      <swiper-slide :class="{ active: tab == 1 }">
        <div @click="$router.push({ name: 'BookingDay' }).catch(() => {})">
          {{ $t("page.booking.booking_date") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: tab == 2 }">
        <div @click="$router.push({ name: 'BookingTable' }).catch(() => {})">
          {{ $t("page.booking.booking_list") }}
        </div>
      </swiper-slide>
    </swiper>

    <ul class="nav nav-pills" id="pills-tab" role="tablist">
      <li class="nav-item col-4" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-1-tab"
          type="button"
          @click="$router.push({ name: 'BookingDay' }).catch(() => {})"
          :class="{ active: $route.name === 'BookingDay' }"
        >
          {{ $t("page.booking.booking_date") }}
        </button>
      </li>
      <li class="nav-item col-4" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-2-tab"
          type="button"
          @click="$router.push({ name: 'BookingTable' }).catch(() => {})"
          :class="{ active: $route.name === 'BookingTable' }"
        >
          {{ $t("page.booking.booking_list") }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "Tab",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      /*swiperOptions: {
        slidesPerView: 'auto',
        freeMode: true
      }*/
    };
  },
  computed: {
    tab: function () {
      if (this.$route.name === "BookingDay") return 1;
      else if (this.$route.name === "BookingTable") return 2;
      else return 0;
    },
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
};
</script>
